const bootstrap = require('bootstrap5');
window.bootstrap = bootstrap;
//legacy code without jquery/lodash
require("./legacy/gateway.js");
require("./legacy/menu-masthead-footer.js");
require("./legacy/populate-hero-nav.js");
require("./legacy/share-widget.js");
require("./legacy/main-nav.js");
require("../override/ahp-modal.js");
require("../override/newsletter-modal.js");
require("../override/promo-etf-modal.js");

function loadCookieDisclaimerScript() {
    if (typeof displayCookiePopup != "function") {
        import(/* webpackChunkName: "cookie-disclaimer" */ './legacy/cookie-disclaimer.js');
    }
}

function loadBannerScript() {
    if (!document.querySelector('body.hide-promo-banner')) {
        import(/* webpackChunkName: "generic-promo-banner" */ './legacy/generic-promo-banner.js');
    }
}

function loadMultiProductPageScript() {
    if (document.querySelector('.multi-product-page')) {
        import(/* webpackChunkName: "multi-product-page" */ './multi-product-page.js');
    }
}

async function loadSpinnerScript() {
    if (document.querySelector('.customized-newsletter')) {
        const { Spinner } = await import('spin.js');
        window.Spinner = Spinner;
        import(/* webpackChunkName: "newsletter-popups" */ './newsletter-popups.js');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    loadBannerScript();
    loadCookieDisclaimerScript();
    loadMultiProductPageScript();
    loadSpinnerScript();
});

//hero banner
require("./legacy/video/landing-page-hero-video.js");
require("./legacy/video/responsive-video.js");
require("./legacy/video/direct-investing-page-videos.js");

//new blocks
require("./accordion-block.js");
require("./semiconductor-industry.js");
require("./semiconductor-industry-text-block.js");
require("./fund-overview.js");
require("./invest-block.js");
require("./other-products-block.js");

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((dropdown) => {
      dropdown.addEventListener('click', function(e) {
          e.stopPropagation();
      });
    })
});